import React, { useEffect, useMemo, useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import { FaEdit, FaEye, FaPlus, FaTrash } from "react-icons/fa";
import MasterService from "../../../../../services/master/MasterService";
import PbUmkuService from "../../../../../services/pbumku/PbumkuService";
import UploadService from "../../../../../services/transaksi/UploadService";
import DataTable from "react-data-table-component";

const ViewCpibDok = ({ dataDokumen, saveDokumen, cancelDokumen }) => {
    const columns = [
        {
            name: 'Seri',
            cell: row => row['trUmkuDokPK'].seri,
            grow: 0
        },
        {
            name: 'Kode Dokumen',
            cell: row => row['idJenisDok']
        },
        {
            name: 'Nomor Dokumen',
            cell: row => row['noDok']
        },
        {
            name: 'Tanggal',
            cell: row => row['tglDok']
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className='row'>
                        <div className='col-sm-3'>
                            <Button size='sm' variant='info'>
                                <FaEye />
                            </Button>
                        </div>
                        {localStorage.getItem('isEditPrimer') === '1' ?
                            <>
                                <div className='col-sm-3'>
                                    <Button size='sm' variant='warning'>
                                        <FaEdit />
                                    </Button>
                                </div>
                                <div className='col-sm-3'>
                                    <Button size='sm' variant='danger'>
                                        <FaTrash />
                                    </Button>
                                </div>
                            </> : ''
                        }
                    </div>
                </>
            )
        }
    ]

    const [listUmkuDok, setListUmkuDok] = useState([])
    const [loading, setLoading] = useState(false)

    let masterService = useMemo(() => new MasterService(), [])
    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    let uploadService = useMemo(() => new UploadService(), [])

    useEffect(() => {
        if (!dataDokumen) return
        setLoading(true)
        setListUmkuDok(dataDokumen.data)
        setLoading(false)
    }, [dataDokumen])

    return (
        <>
            <div className="form-card text-start">
                <div className="row">
                    <div className="col-7">
                        <h6 className="mb-4">Data Pengajuan : {localStorage.getItem('nomorAjuPrimerStorage')} </h6>
                    </div>
                </div>
                <div className="row">
                    {
                        localStorage.getItem('isEditPrimer') === '1' ?
                            <div className="col-7">
                                <Button type="button" variant="primary" size="sm"><FaPlus />Tambah Dokumen</Button>
                            </div> : ''
                    }
                </div>
            </div>
            <div className="table-responsive border-bottom my-3">
                {(loading && <Spinner />)}
                <DataTable
                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                    columns={columns}
                    data={listUmkuDok}
                    highlightOnHover
                    pagination
                    persistTableHead={true}
                />
            </div>
        </>
    )
}

export default ViewCpibDok